(function($) {

  // var tabControler = new TabControler();
  // tabControler.set_tabselector('.block__events-section');
  // tabControler.render();

  var agenda_controler = new AgendaControler();
  agenda_controler.init();


  $(".sound-toggle").on('click', function(e) {
    $(this).toggleClass('muted');
    $('.has-video video').prop("muted", !$('.has-video video').prop("muted"));
  });

})(jQuery);